<template>

    <v-page fixed>

        <v-page-header icon="fas fa-tag">
            <v-breadcrumb>
                <v-breadcrumb-item><router-link :to="{ name: 'tags' }">Tags</router-link></v-breadcrumb-item>
                <v-breadcrumb-item v-if="tag">{{ tag.name }}</v-breadcrumb-item>
            </v-breadcrumb>
        </v-page-header>

        <v-page-filters>
            <v-identifier v-if="tag" :uuid="tag.id" />
            <v-button size="sm" @click.native="updateTag" :loading="loading">Save Tag</v-button>
        </v-page-filters>

        <v-page-body>

            <v-page-section>
                <template #title>Tag</template>
                <template #body>
                    <v-form-group label="Name">
                        <v-input class="w-300" :model="params.name" @input="params.name = $event" />
                    </v-form-group>
                    <v-form-group label="Color">
                        <v-input-color class="w-300" :model="params.color" @input="params.color = $event" />
                    </v-form-group>
                    <v-form-group label="Description">
                        <v-textarea :rows="3" :model="params.description" @input="params.description = $event" />
                    </v-form-group>
                </template>
            </v-page-section>

        </v-page-body>

    </v-page>

</template>

<script>

import TagApi from '@api/TagApi';

export default {

    mounted() {
        this.getTag();
    },

    data() {
        return {
            loading: false,
            tag: null,
            params: {},
        }
    },

    methods: {

        getTag() {
            this.$store.commit('loading', true);
            TagApi.getTag(this.$route.params.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.tag = response.data.data;
                    this.params = { ...this.tag };
                    this.$events.$emit('pageLoaded');
                })
                .catch(() => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        updateTag() {
            this.loading = true;
            TagApi.updateTag(this.tag.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                })
                .catch((error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    }

}

</script>